<template>
  <div class="section py-0 px-5">
    <div class="tile app-title">
      <p class="subtitle is-6">Par date</p>
    </div>
    <b-datepicker placeholder="Cliquer ici..."
                  icon="calendar-today"
                  v-model="dateDeVisualisation"
                  :readonly="false"
                  :show-week-number="true"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/venteReseauxTempo-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';

const VenteReseauxTempo = createNamespacedHelpers('venteReseauxTempo');

export default {
  name: 'date',
  data() {
    return {
    };
  },
  computed: {
    ...VenteReseauxTempo.mapGetters({
      getDateDeVisualisation: 'dateDeVisualisation',
    }),
    dateDeVisualisation: {
      get() {
        return this.getDateDeVisualisation;
      },
      set(value) {
        this.setDateDeVisualisation(value);
        this.rechercheVentesReseaux();
      },
    },
  },
  methods: {
    ...VenteReseauxTempo.mapMutations({
      setDateDeVisualisation: types.SET_DATE_DE_VISUALISATION,
    }),
    ...VenteReseauxTempo.mapActions({
      actionRechercheReseaux: 'rechercheReseaux',
    }),
    rechercheVentesReseaux() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.actionRechercheReseaux().then(() => {
        loadingComponent.close();
      }).catch((e) => {
        loadingComponent.close();
        gestionErreur('Erreur lors de la recherche des réseaux tempos liée à la date', e);
      });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxTempo/filtres/date.vue